import { render } from "./CV.vue?vue&type=template&id=74e9f549&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=74e9f549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e9f549"]])

export default __exports__